import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {SessionService} from 'src/app/services/session.service';

@Component({
  selector: 'app-enterprise-active-users',
  templateUrl: './active-user.component.html',
  styleUrls: ['./active-user.component.scss']
})
export class ActiveUserComponent implements OnInit {
  devMode = false;
  elements: any = [];
  inProgress = false;
  sameUser = false;
  @Input() canInviteUser = false;
  @Input() user;
  @Output() refreshSession = new EventEmitter();

  constructor(private trustiiService: TrustiiService, private sessionService: SessionService) {
  }

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit(): void {
    this.devMode = !environment.production;
    this.sameUser = this.user.id === this.sessionService.getUser().id;
  }

  updateUser(): void {
    // todo
    this.inProgress = true;
    const data = {
      active: (this.user.active === 'yes') ? 'no' : 'yes',
    };
    this.trustiiService.updateUser(this.user.id, data).subscribe(
      (res) => {
        this.user.active = res.data.active;
        this.refreshSession.emit(true);
        this.inProgress = false;
      },
      (err) => {
        this.inProgress = false;
      }
    );
  }
}
